import React from 'react';
import { motion } from 'framer-motion';
import { CircleDotIcon, CarIcon, UsersIcon, SparklesIcon } from 'lucide-react';
import { features } from '../data/site';
import { useLanguage } from '../contexts/LanguageContext';
import { useMotionPreferences } from '../hooks/useMotionPreferences';
import { TiltCard } from './motion/TiltCard';
import { fadeUp, staggerContainer, viewportOnce } from '../utils/motion';
const icons = {
  court: CircleDotIcon,
  parking: CarIcon,
  community: UsersIcon,
  levels: SparklesIcon
};
export function Features() {
  const {
    reduced
  } = useMotionPreferences();
  const {
    t
  } = useLanguage();
  const item = fadeUp(reduced, 30);
  return <section id="courts" className="relative w-full overflow-hidden py-28" data-id="element-44" data-mp="1a9o3m3ltajhf">
      <div className="pointer-events-none absolute left-1/2 top-24 h-96 w-[42rem] -translate-x-1/2 rounded-full bg-grape/15 blur-[160px]" data-id="element-45" data-mp="1e73rvwhz636k" />

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8" data-id="element-46" data-mp="2ti5gj3i2foq">
        <motion.div variants={staggerContainer(0.1)} initial="hidden" whileInView="show" viewport={viewportOnce} className="max-w-2xl" data-id="element-47" data-mp="2rnfurha9zeb">
          <motion.p variants={item} className="text-xs font-semibold uppercase tracking-[0.28em] text-magenta" data-id="element-48" data-mp="2swokld2ahyx0">
            {t.features.eyebrow}
          </motion.p>
          <motion.h2 variants={item} className="neon-text mt-4 font-display text-4xl font-black uppercase leading-[1.02] tracking-tight text-white sm:text-5xl" data-id="element-49" data-mp="32v4ajcpkz24x">
            {t.features.titleLines[0]}
            <br data-id="element-50" data-mp="3qicbxjjw1r1o" />
            {t.features.titleLines[1]}
          </motion.h2>
          <motion.p variants={item} className="mt-5 text-base leading-relaxed text-white/60" data-id="element-51" data-mp="3qkf2c4oydm6x">
            {t.features.intro}
          </motion.p>
        </motion.div>

        <motion.div variants={staggerContainer(0.09, 0.08)} initial="hidden" whileInView="show" viewport={viewportOnce} className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-52" data-mp="3efp1u7lr1va">
          {features.map((feature, i) => {
          const Icon = icons[feature.icon];
          const copy = t.features.cards[i];
          return <TiltCard key={feature.icon} as="article" variants={item} maxTilt={9} className="glass group relative h-full overflow-hidden rounded-3xl p-7 transition-[box-shadow,border-color] duration-300 hover:border-electric/50 hover:shadow-[0_0_60px_-10px_rgba(30,155,233,0.8)]" data-id="element-53" data-mp="315wn7es8uvm9" data-mpi={i}>
                <div className="pointer-events-none absolute -right-10 -top-10 h-28 w-28 rounded-full bg-magenta/20 blur-3xl transition-colors duration-500 group-hover:bg-electric/40" data-id="element-54" data-mp="3kwi4clxyqc8b" />
                <span className="relative inline-flex h-12 w-12 items-center justify-center rounded-2xl border border-white/15 bg-gradient-to-br from-electric/25 to-magenta/25 text-white" data-id="element-55" data-mp="1qi7fidhdbi2j">
                  <Icon className="h-5 w-5" data-id="element-56" data-mp="1n01kt3f6b9d4" />
                </span>
                <h3 className="relative mt-6 font-display text-lg font-extrabold uppercase tracking-[0.06em] text-white" data-id="element-57" data-mp="1n1col38mch48">
                  {copy.title}
                </h3>
                <p className="relative mt-3 text-sm leading-relaxed text-white/60" data-id="element-58" data-mp="1da881z3aoo7a">
                  {copy.description}
                </p>
              </TiltCard>;
        })}
        </motion.div>
      </div>
    </section>;
}